import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import Tile from "./Tile";

/** Drag-sortable wrapper around a <Tile />. Drag is only active when
 * `editing=true`. Tap-to-speak still works on the tile button itself.
 */
export default function SortableTile({ tile, size, editing, ...rest }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: tile.id,
    disabled: !editing,
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 10 : "auto",
  };
  return (
    <div ref={setNodeRef} style={style} className="relative" data-testid={`sortable-tile-${tile.id}`}>
      <Tile tile={tile} size={size} editing={editing} {...rest} />
      {editing && (
        <button
          type="button"
          {...attributes}
          {...listeners}
          className="absolute -top-3 -left-3 bg-white border-[3px] border-[color:var(--ink)] rounded-full w-9 h-9 flex items-center justify-center shadow-[3px_3px_0_0_var(--ink)] cursor-grab active:cursor-grabbing touch-none"
          aria-label="Drag to reorder"
          data-testid={`drag-handle-${tile.id}`}
        >
          <GripVertical size={16} />
        </button>
      )}
    </div>
  );
}
